import { render } from "./ContactHead.vue?vue&type=template&id=50495ba8&scoped=true"
import script from "./ContactHead.vue?vue&type=script&lang=js"
export * from "./ContactHead.vue?vue&type=script&lang=js"

import "./ContactHead.vue?vue&type=style&index=0&id=50495ba8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50495ba8"]])

export default __exports__